namespace SP {
    export enum PurchaseOrderState {
        None = 0,
        Open = 1,
        Ordered = 2,
        Closed = 3,
        Canceled = 4
    }
}